import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap-vue/dist/bootstrap-vue.js'
import '@popperjs/core'
// import * as Sentry from '@sentry/vue';

// Sentry.init({
// 	Vue: Vue,
// 	dsn: window.NSTS_CONFIG["sentry_url"],
// 	logErrors: true,
// });

Vue.config.productionTip = false
Vue.use(BootstrapVue)
import jQuery from 'jquery'

Vue.mixin({
	data()
	{
		return {
			NSTS_CONFIG: window.NSTS_CONFIG,
			app_name: window.NSTS_CONFIG["app_name"],
			editing: false,
			loading_count: 0
		}
	},
	methods:
	{
		CORS(request_type, request_url, request_data, success_callback, fail_callback)
		{
			var vm = this;

			jQuery.ajax(
			{
				type: request_type,
				url: vm.NSTS_CONFIG["api_server"] + request_url,
				data: request_data,
				xhrFields: {
					withCredentials: true
				},
				crossDomain: true,
				beforeSend: function(xhr) {
					xhr.setRequestHeader("X-CSRF-TOKEN", vm.getCookie("csrf_access_token"));
				}
			}).done(function(data)
			{
				if(typeof success_callback == "function")
				{
					success_callback(data);
				}
			}).fail(function(data)
			{
				if(typeof fail_callback == "function")
				{
					fail_callback(data);
				}
			});
		},
		setCookie(cname,cvalue,exdays)
		{
			var d = new Date();
			d.setTime(d.getTime()+(exdays*24*60*60*1000));
			var expires = "expires="+d.toGMTString();
			document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;SameSite=Strict";
		},
		getCookie(cname)
		{
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for(var i=0; i<ca.length; i++)
			{
				var c = ca[i].trim();
				if (c.indexOf(name)==0)
					return c.substring(name.length,c.length);
			}
			return "";
		},
		retina: function(src)
		{
			if(window.devicePixelRatio == 2)
			{
				return src.replace(/\.(png|PNG|jpe?g|JPE?G)$/, "@2x.$1");
			}
			else
			{
				return src;
			}
		},
		close: function()
		{
			this.$router.go(-1);
		},
		closeModals: function()
		{
			jQuery(".modal").each(function()
			{
				var me = jQuery(this);

				if(me.hasClass("fade"))
				{
					me.removeClass("fade");
					me.modal("hide");
					me.addClass("fade");
				}
				else
				{
					me.modal("hide");
				}
			});
		},
		nerivon_confirm: function(title, message, type, close_after, callback)
		{
			// var vm = this;
			var icon = "";

			jQuery('#nvModal').detach();

			if(callback == null)
			{
				callback = function() {};
			}

			if(type == "warning")
			{
				icon = '<em class="fas fa-exclamation-circle text-warning"></em>';
			}
			else if(type == "error")
			{
				icon = '<em class="fas fa-exclamation-circle text-danger"></em>';
			}
			else if(type == "success")
			{
				icon = '<em class="fas fa-check-circle text-success"></em>';
			}
			else if(type == "info")
			{
				icon = '<em class="fas fa-info-circle text-info"></em>';
			}

			jQuery("body").prepend('<div class="modal fade" tabindex="-1" role="dialog" id="nvModal"> \
				<div class="modal-dialog modal-dialog-centered" role="document"> \
					<div class="modal-content"> \
						<div class="modal-header"> \
							<h3 class="modal-title">' + icon + ' ' + title + '</h3> \
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"> \
							<span aria-hidden="true">&times;</span> \
							</button> \
						</div> \
						<div class="modal-body text-center">' + message + '</div> \
						<div class="modal-footer text-center"> \
							<input type="hidden" id="nvModalAnswer" value="" /> \
							<button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = 0">No</button> \
							<button type="button" class="btn btn-primary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = 1">Yes</button> \
						</div> \
					</div> \
				</div> \
			</div>');

			var vm = this;

			jQuery('#nvModal').on('shown.bs.modal', function ()
			{
				jQuery('#nvModal input[autofocus]').focus();
			});

			jQuery('#nvModal').on('hidden.bs.modal', function ()
			{
				var nvModalAnswer = document.getElementById("nvModalAnswer").value;
				jQuery('#nvModal').detach();
				// Make sure all modals are closed. Sometimes the backdrop gets stuck.
				vm.closeModals();
				callback((nvModalAnswer == 1 ? true : false));
			});

			jQuery("#nvModal").modal("show");
		},
		nerivon_alert: function(title, message, type, close_after, callback)
		{
			// var vm = this;
			var icon = "";

			jQuery('#nvModal').detach();

			if(callback == null)
			{
				callback = function(isConfirm)
				{
					return isConfirm;
				};
			}

			if(type == "warning")
			{
				icon = '<em class="fas fa-exclamation-circle text-warning"></em>';
			}
			else if(type == "error")
			{
				icon = '<em class="fas fa-exclamation-circle text-danger"></em>';
			}
			else if(type == "success")
			{
				icon = '<em class="fas fa-check-circle text-success"></em>';
			}
			else if(type == "info")
			{
				icon = '<em class="fas fa-info-circle text-info"></em>';
			}

			jQuery("body").prepend('<div class="modal fade" tabindex="-1" role="dialog" id="nvModal"> \
				<div class="modal-dialog modal-dialog-centered" role="document"> \
					<div class="modal-content"> \
						<div class="modal-header"> \
							<h3 class="modal-title">' + icon + ' ' + title + '</h3> \
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"> \
							<span aria-hidden="true">&times;</span> \
							</button> \
						</div> \
						<div class="modal-body text-center">' + message + '</div> \
						<div class="modal-footer text-center"> \
							<input type="hidden" id="nvModalAnswer" value="" /> \
							<button type="button" class="btn btn-primary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = 1">Ok</button> \
						</div> \
					</div> \
				</div> \
			</div>');

			jQuery('#nvModal').on('shown.bs.modal', function ()
			{
				jQuery('#nvModal input[autofocus]').focus();
			});

			jQuery('#nvModal').on('hidden.bs.modal', function ()
			{
				var nvModalAnswer = document.getElementById("nvModalAnswer").value;
				jQuery('#nvModal').detach();
				callback((nvModalAnswer == 1 ? true : false));
			});

			jQuery("#nvModal").modal("show");
		},
		nerivon_input: function(title, message, close_after, callback)
		{
			// var vm = this;
			jQuery('#nvModal').detach();

			if(callback == null)
			{
				callback = function() {};
			}

			jQuery("body").prepend('<div class="modal fade" tabindex="-1" role="dialog" id="nvModal"> \
				<div class="modal-dialog modal-dialog-centered" role="document"> \
					<div class="modal-content"> \
						<div class="modal-header"> \
							<h3 class="modal-title"><em class="fas fa-keyboard"></em> ' + title + '</h3> \
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"> \
							<span aria-hidden="true">&times;</span> \
							</button> \
						</div> \
						<div class="modal-body text-center">' + message + '<br><br><input id="nvModalInput" class="form-control" autofocus /></div> \
						<div class="modal-footer text-center"> \
							<button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = 0">Cancel</button> \
							<button type="button" class="btn btn-primary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = document.getElementById(\'nvModalInput\').value">Ok</button> \
						</div> \
					</div> \
				</div> \
			</div>');

			jQuery('#nvModal').on('shown.bs.modal', function ()
			{
				jQuery('#nvModal input[autofocus]').focus();
			});

			jQuery('#nvModal').on('hidden.bs.modal', function ()
			{
				var nvModalAnswer = document.getElementById("nvModalAnswer").value;
				jQuery('#nvModal').detach();
				callback((nvModalAnswer == 0 ? false : nvModalAnswer));
			});

			jQuery("#nvModal").modal("show");
		},
		nerivon_choice: function(title, message, type, choices, close_after, callback)
		{
			// var vm = this;
			var icon = "";
			var choices_html = "";

			jQuery('#nvModal').detach();

			if(callback == null)
			{
				callback = function() {};
			}

			if(type == "warning")
			{
				icon = '<em class="fas fa-exclamation-circle text-warning"></em>';
			}
			else if(type == "error")
			{
				icon = '<em class="fas fa-exclamation-circle text-danger"></em>';
			}
			else if(type == "success")
			{
				icon = '<em class="fas fa-check-circle text-success"></em>';
			}
			else if(type == "info")
			{
				icon = '<em class="fas fa-info-circle text-info"></em>';
			}

			for(var i=0; i<choices.length; i++)
			{
				choices_html += '<button type="button" class="btn btn-primary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = \'' + choices[i][0] + '\'">' + choices[i][1] + '</button>';
			}

			jQuery("body").prepend('<div class="modal fade" tabindex="-1" role="dialog" id="nvModal"> \
				<div class="modal-dialog modal-dialog-centered" role="document"> \
					<div class="modal-content"> \
						<div class="modal-header"> \
							<h3 class="modal-title">' + icon + ' ' + title + '</h3> \
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"> \
							<span aria-hidden="true">&times;</span> \
							</button> \
						</div> \
						<div class="modal-body text-center">' + message + '</div> \
						<div class="modal-footer text-center"> \
							<input type="hidden" id="nvModalAnswer" value="" />' + choices_html + ' \
							<button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="document.getElementById(\'nvModalAnswer\').value = \'\'">Cancel</button> \
						</div> \
					</div> \
				</div> \
			</div>');

			jQuery('#nvModal').on('shown.bs.modal', function ()
			{
				jQuery('#nvModal input[autofocus]').focus();
			});

			jQuery('#nvModal').on('hidden.bs.modal', function ()
			{
				var nvModalAnswer = document.getElementById("nvModalAnswer").value;
				jQuery('#nvModal').detach();
				callback(nvModalAnswer);
			});

			jQuery("#nvModal").modal("show");
		},
		showWarning: function(message, text, close_after, callback)
		{
			this.nerivon_confirm(message, text, "warning", close_after, callback);
		},
		showError: function(message, text, close_after, callback)
		{
			this.nerivon_alert(message, text, "error", close_after, callback);
		},
		showSuccess: function(message, text, close_after, callback)
		{
			this.nerivon_alert(message, text, "success", close_after, callback);
		},
		showInfo: function(message, text, close_after, callback)
		{
			this.nerivon_alert(message, text, "info", close_after, callback);
		},
		startLoading: function()
		{
			this.loading_count++;
			jQuery(".loading").addClass("fa-circle-notch fa-spin");
			jQuery("input, select, button").attr("disabled", true);
			// this.showToast("<em class='fas fa-circle-notch fa-spin'></em> Please Wait...", this.loading_count, (this.loading_count == 1 ? "1 item is" : this.loading_count + " items are") + " processing.", false);
		},
		stopLoading: function()
		{
			this.loading_count--;

			if(this.loading_count < 0)
			{
				this.loading_count = 0;
			}

			if(this.loading_count == 0)
			{
				jQuery(".loading").removeClass("fa-circle-notch fa-spin");
				jQuery("input, select, button").removeAttr("disabled");
				// jQuery("#toast").toast("hide");
			}
			// else
			// {
			// 	this.showToast("<em class='fas fa-circle-notch fa-spin'></em> Please Wait...", this.loading_count, (this.loading_count == 1 ? "1 item is" : this.loading_count + " items are") + " processing.", false);
			// }
		},
		userHasAction: function(user, actions)
		{
			if(user == null || typeof user.actions == "undefined" || user.actions == null)
			{
				return false;
			}

			for(var i=0; i<user.actions.length; i++)
			{
				for(var j=0; j<actions.length; j++)
				{
					if(user.actions[i].constant == actions[j])
					{
						return true;
					}
				}
			}

			return false;
		},
		runDir: function(run)
		{
			if(run["run_id"].indexOf("_PU") !== -1 ||
				run["run_id"].indexOf(" PU") !== -1 ||
				run["run_id"].indexOf("_AM") !== -1 ||
				run["run_id"].indexOf(" AM") !== -1 ||
				run["run_id"].indexOf("AM_") !== -1 ||
				run["run_id"].endsWith("AM"))
			{
				return "PU";
			}
			else if(run["run_id"].indexOf("_DO") !== -1 ||
				run["run_id"].indexOf(" DO") !== -1 ||
				run["run_id"].indexOf("_PM") !== -1 ||
				run["run_id"].indexOf(" PM") !== -1 ||
				run["run_id"].indexOf("PM_") !== -1 ||
				run["run_id"].endsWith("PM"))
			{
				return "DO";
			}
			else
			{
				return "??";
			}
		},
		phoneFormat: function(obj, field)
		{
			obj[field] = this.phoneDisplay(String(obj[field]))
		},
		phoneDisplay: function(input)
		{
			var value = String(input)

			if(value.indexOf("+1.") !== false)
			{
				value = value.replace("+1.", "");
			}

			value = value.replace(/[^0-9]/g, '');
			var length = value.length;

			if(length == 3)
			{
				// Leave value as-is.
			}
			else if(length <= 6)
			{
				value = value.replace(/([0-9]{3}?)([0-9]{1,3}?)/g, '$1-$2')
			}
			else if(length <= 10)
			{
				value = value.replace(/([0-9]{3}?)([0-9]{3}?)([0-9]{1,4}?)?/g, '$1-$2-$3')
			}
			else
			{
				value = value.replace(/([0-9]{3}?)([0-9]{3}?)([0-9]{4}?)([0-9]{1,5}?)?/g, '$1-$2-$3 x$4')
			}

			return value;
		}
	}
});


function cleandate(input)
{
	if(input instanceof Date)
	{
		try
		{
			input = input.toISOString();
		}
		catch(e)
		{
			return;
		}
	}

	if(typeof input == "undefined" || input == null || input == "0000-00-00 00:00:00" || input == "0000-00-00")
	{
		return "";
	}

	try
	{
		// The first two : are part of the date. For some reason EXIF data uses yyyy:mm:dd hh:mm:ss.
		input = input.replace(" ", "T").replace(/([0-9]{4}):([0-9]{2}):([0-9]{2})T(.*)/, "$1-$2-$3T$4");
	}
	catch(e)
	{
		return "";
	}

	return input;
}

var long_months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var short_months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

Vue.filter('shortDate', function(input)
{
	var cleaned = cleandate(input);

	if(cleaned != "")
	{
		var d = new Date(cleaned);
		return short_months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
	}
	else
	{
		return "N/A";
	}
});

Vue.filter('phoneDisplay', function(input)
{
	var value = String(input)

	if(value.indexOf("+1.") !== false)
	{
		value = value.replace("+1.", "");
	}

	value = value.replace(/[^0-9]/g, '');
	var length = value.length;

	if(length == 3)
	{
		// Leave value as-is.
	}
	else if(length <= 6)
	{
		value = value.replace(/([0-9]{3}?)([0-9]{1,3}?)/g, '$1-$2')
	}
	else if(length <= 10)
	{
		value = value.replace(/([0-9]{3}?)([0-9]{3}?)([0-9]{1,4}?)?/g, '$1-$2-$3')
	}
	else
	{
		value = value.replace(/([0-9]{3}?)([0-9]{3}?)([0-9]{4}?)([0-9]{1,5}?)?/g, '$1-$2-$3 x$4')
	}

	return value;
});

Vue.filter('longDateTime', function(input)
{
	var cleaned = cleandate(input);

	if(cleaned != "")
	{
		var d = new Date(cleaned);
		var hours = d.getHours();
		var minutes = d.getMinutes();
		var ampm = "am";

		if(hours == 12)
		{
			ampm = "pm";
		}
		else if(hours > 12)
		{
			ampm = "pm";
			hours -= 12;
		}

		if(hours < 10)
		{
			hours = "0" + hours;
		}

		if(minutes < 10)
		{
			minutes = "0" + minutes;
		}

		return long_months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear() + " at " + hours + ":" + minutes + ampm;
	}
	else
	{
		return "N/A";
	}
});

Vue.filter('longDate', function(input)
{
	var cleaned = cleandate(input);

	if(cleaned != "")
	{
		var d = new Date(cleaned);
		return long_months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
	}
	else
	{
		return "N/A";
	}
});

Vue.filter('longDate2', function(input)
{
	var cleaned = cleandate(input);

	if(cleaned != "")
	{
		var d = new Date(cleaned);
		return days[d.getDay()] + ", " + long_months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
	}
	else
	{
		return "N/A";
	}
});

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
